import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';


/* ==============================
Filters Component
================================ */
export function ProjectFilters({ filters, setFilters, onApply }) {
    return (
        <div className="card mb-4 noprint">
            <div className="card-body" style={{background:"#eee"} }>
                <div className="row g-3">
                    <div className="col-md-3">
                        <label className="form-label">Farm Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search farm..."
                            value={filters.farm}
                            onChange={(e) =>
                                setFilters({ ...filters, farm: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-3 select">
                        <label className="form-label">Referred By</label>
                        <select
                            onChange={e => setFilters({ ...filters, referredBy: e.target.value })}
                            className="form-control"
                            value={filters.referredBy}
                        >
                            <option value="" >All</option>
                            <option value="ADAS">ADAS</option>
                            <option value="Agrovista">Agrovista</option>
                            <option value="Aspatria Farmers">Aspatria Farmers</option>
                            <option value="Eco Prospects">Eco Prospects</option>
                            <option value="Glasson">Glasson</option>
                            <option value="Mitchells">Mitchells</option>
                            <option value="NWA">NWA</option>
                            <option value="Other">Other</option>

                        </select>
                    </div>
                    

                    <div className="col-md-6">
                        <label className="form-label">Project Title</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search title..."
                            value={filters.title}
                            onChange={(e) =>
                                setFilters({ ...filters, title: e.target.value })
                            }
                        />
                    </div>
                </div>
                <div className="row g-3">

                    <div className="col-md-3 select">
                        <label className="form-label">Project Year</label>
                        <select
                            className="form-select"
                            value={filters.year}
                            onChange={(e) =>
                                setFilters({ ...filters, year: e.target.value })
                            }
                        >
                            <option value="">All</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                        </select>
                    </div>


                    <div className="col-md-3 select">
                        <label className="form-label">Status</label>
                        <select
                            className="form-select"
                            value={filters.status}
                            onChange={(e) =>
                                setFilters({ ...filters, status: e.target.value })
                            }
                        >
                            <option value="All">All</option>
                            <option value="Active">Active</option>
                            <option value="Created">Created</option>
                            <option value="To Start">To Start</option>
                            <option value="On Hold">On Hold</option>
                            <option value="In Progress">In Progress</option>
                            <option value="To Invoice">To Invoice</option>
                            <option value="Completed">Completed</option>
                            <option value="Cancelled">Cancelled</option>
                        </select>
                    </div>
                


                    <div className="col-md-6 d-flex flex-column">
                        <button
                            className="btn btn-primary mt-auto ms-auto"
                            onClick={onApply}
                        >
                            Apply Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}